import React, {useContext} from 'react';
import {Context} from '../../hooks/Store';
import "./c81_corsi_e_master.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import Dropdown from "react-dropdown";
import magnifier from "../../assets/magnifier.svg";
import axios from "axios";

const SVG_ID = "#svg_id";

const CorsiEMasterSearch = (props) => {
    let dropdownSelection = '';
    const [state, dispatch] = useContext(Context);

    const writeDepartment = event => {
        event.preventDefault();
        callCards();
    }

    const changeDepartment = selected => {
        dispatch({type: 'c81SelectedDepartment', payload: selected.value});
        const dropdownObject = state.dipartimento.filter(object => {
            return object.label === selected.value
        });
        dropdownSelection = dropdownObject[0].id
        callCards();
    }

    const callCards = () => {
        let params = {};

        params['department'] = dropdownSelection !== 'All' ? params['department'] = dropdownSelection : '';
        params['search'] = (document.forms.departmentForm && document.forms.departmentForm.search && document.forms.departmentForm.search.value) &&
            document.forms.departmentForm.search.value;


        axios.get(state.cardLinkForFiltering, {params: params}).then(response => {
            dispatch({type: 'c82CardsData', payload: response.data.items});
            dispatch({type: 'c82NextCardsEndpoint', payload: response.data.next_page});
        });
    };

    return <div id="corsiemaster">
        <div className={isMobileOnly ? "" : "col-4"}>
            <form onSubmit={writeDepartment} name="departmentForm"
                  className={!isMobileOnly ? 'search-bar-courses_prefiltered' : 'search-bar-courses_prefiltered mobile-size'}>
                <input name="search" className={isMobileOnly ? "search-input-mob" : "search-input"} placeholder="What do you want to study?"/>
                <button className="courses_prefiltered-search-button">
                    <svg className="magnifier-courses_prefiltered">
                        <use xlinkHref={`${magnifier}${SVG_ID}`}/>
                    </svg>
                </button>
            </form>
        </div>
        <div className={isMobileOnly ? "" : "col-4"}>
            <Dropdown id="dipartimentoValue" options={state.dipartimento} onChange={changeDepartment} value={state.selectedDepartment}
                      className={isMobileOnly ? 'mobile-size c81-Dropdown' : 'c81-Dropdown'}/>
        </div>
        {!isMobileOnly ? <div className="btn-group-vertical button-section">
            {props.data.links ? props.data.links.map((object, index) =>
                <a key={index} className={object.selected ? "btn menubutton-selected" : "btn menubutton"} href={object.url}>{object.label}</a>
            ) : null}
        </div> : <div className="scrolling-wrapper">
            {props.data.links ? props.data.links.map((object, index) =>
                <a key={index} className={object.selected ? "btn menubutton-selected" : "btn menubutton"} href={object.url}>{object.label}</a>
            ) : null}
            {state.c83Data !== "" && <a className="C83Banner" href={state.c83Data.link}>
                <div className="img-container">
                    <img className="image-card" src={state.c83Data.image} alt={state.c83Data.title}/>
                </div>
                <div className="card-body">
                    <span className="title">{state.c83Data.title}</span>
                    <span className="arrow">&#8594;</span>
                </div>
            </a>}
            <div className="ending-space"/>
        </div>}
    </div>;
};

class C81CorsiEMaster extends TemplateComponent {
    componentRender(data) {
        return (
            <CorsiEMasterSearch data={data}/>
        );
    };
};

export default C81CorsiEMaster;
